import { inject, Injectable } from '@angular/core';
import { ListingExportConfig } from '@portal/shared/types/listing.types';
import { ExportRow } from '@portal/shared/types/export.types';
import { TableData } from 'src/app/shared/types/api-response.types';
import { History } from '../services/history-api.types';
import { HistoryDataService } from '../services/history-data.service';
import { mapHistoryToExport } from './history-log-listing.export';

@Injectable()
export class HistoryLogListingExportConfigService implements ListingExportConfig {
  private readonly history = inject(HistoryDataService);

  readonly fileName = 'Export-HistoryLog';

  readonly mapData = (data: TableData<History>): ExportRow[] =>
    data.data.map(item =>
      mapHistoryToExport(item, (values, updateType) => this.history.prepareValuesForExport(values, updateType))
    );
}
